export default "__VITE_ASSET__CEDzp8r5__"